<template>
    <card title="Compound Ingredient Drug Selection">
        <div v-if="!isLoading">
            <b-row class="pb-1 align-items-center">
                <b-col>
                    <SearchComponent v-model="drugSearch"
                                     :label="`Drug`"
                                     :params="{ onlyActive : true }"
                                     :search-u-r-l="`/Drug`"
                                     @input="onDrugSearchSelected"
                    >
                    </SearchComponent>
                </b-col>
                <b-col cols="2">
                    <b-button :block="true"
                              variant="danger"
                              @click="clearClicked">
                        Clear
                    </b-button>
                </b-col>
            </b-row>

            <!--b-row v-show="drugName" class="text-center">
                <b-col>
                    <h2>{{this.drugName}}</h2>
                </b-col>
            </b-row-->
            <b-row>
                <b-col v-show="nonGSDDDrug && nonGSDDDrug.productID>0" class="py-2">
                    <card>
                        <b-row>
                            <b-col cols="9">
                                <h3 class="card-subtitle"> {{nonGSDDTitle}} </h3>
                                <b-alert variant="danger">Danger Alert</b-alert>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <span id="brand-filler" class="filler"><strong> &nbsp;</strong></span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>ProductID: </strong>{{this.nonGSDDDrug?.productID}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>NDC: </strong>{{this.nonGSDDDrug && this.nonGSDDDrug.ndc}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>AWP: </strong>{{this.awp}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Package Size: </strong>{{this.packageSize}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Unit of Measure: </strong>{{this.unitOfMeasure}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Minimum Dispense Quantity: </strong>{{this.minimumDispenseQuantity}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>DEA Class: </strong>{{this.deaClass}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Status: </strong>{{this.nonGSDDStatus}}
                            </b-col>
                        </b-row>
                    </card>
                </b-col>

                <b-col v-show="gsddDrug && gsddDrugPackageId>0">
                    <card>
                        <b-row>
                            <b-col cols="9">
                                <h3 class="card-subtitle"> {{gsddTitle}} </h3>
                                <b-alert variant="danger">Danger Alert</b-alert>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <span id="patient-education-filler-1" class="filler"><strong> &nbsp;</strong></span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>PackageId: </strong>{{this.gsddDrug?.packageID}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>NDC: </strong>{{this.gsddDrug && this.gsddDrug.ndc}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Marketer: </strong>{{this.marketer}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Description: </strong>{{this.packageDescription}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Dose Form: </strong>{{this.doseForm}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>DEA Class: </strong>{{this.gsddDeaClass}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Package Size: </strong>{{this.gsddPackageSize}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Unit Price: </strong>{{this.drugPrice}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Route of
                                    Administration: </strong>{{this.gsddDrug && this.gsddDrug.routeOfAdministration}}
                            </b-col>
                        </b-row>
                    </card>
                </b-col>

                <b-col v-show="compoundDrug && compoundDrug.compoundID>0" class="py-2">
                    <card>
                        <b-row>
                            <b-col cols="9">
                                <h3 class="card-subtitle"> {{compoundTitle}} </h3>
                                <b-alert variant="info">Compound Drug</b-alert>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <span id="compound-filler" class="filler"><strong> &nbsp;</strong></span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Compound ID: </strong>{{this.compoundDrug?.compoundID}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>NDC: </strong>{{this.compoundDrug && this.compoundDrug.ndc}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Name: </strong>{{this.compoundName}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>AWP: </strong>{{this.compoundAwp}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Package Size: </strong>{{this.compoundPackageSize}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Unit of Measure: </strong>{{this.compoundUnitOfMeasure}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Minimum Dispense Quantity: </strong>{{this.compoundMinimumDispenseQuantity}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>DEA Class: </strong>{{this.compoundDeaClass}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Status: </strong>{{this.compoundStatus}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <strong>Ingredients: </strong>{{this.compoundIngredientsCount}}
                            </b-col>
                        </b-row>
                    </card>
                </b-col>

            </b-row>
            <b-form-row>
                <b-col cols="5">
                    <fg-input v-model.number="ingredientQuantity"
                              :disabled="disableFields"
                              :no-wheel="true"
                              label="Quantity"
                              placeholder="0.0000"
                              required
                              type="number">
                    </fg-input>
                </b-col>
                <b-col cols="5">
                    <fg-input v-model.number="ingredientUom"
                              :disabled="disableFields"
                              label="Unit Of Measure"
                              required>
                    </fg-input>
                </b-col>
            </b-form-row>

            <b-col cols="12">
                <b-button :disabled="!drugSelected" variant="success" @click="onSaveClicked">Add Ingredient</b-button>
                <b-button @click="onCancelClicked">Cancel</b-button>
            </b-col>
        </div>
    </card>
</template>
<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { Drug, DrugStatus } from '@/models/Drug/Drug';
    import { NonGSDDDrug } from '@/models/Drug/NonGSDDDrug';
    import { CompoundDrug } from '@/models/Drug/CompoundDrug';
    import { PackagePrice } from '@/models/GSDD';
    import SearchComponent from '@/components/SearchComponent.vue';
    import { DrugSource } from '@/models/Drug/DrugProduct';
    import Axios from "axios";
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

    @Component({
        name: "IngredientSelectModalComponent",
        components: {
            SearchComponent
        }
    })

    export default class IngredientSelectModalComponent extends Vue {
        @Prop() private currentCompoundId!: number;

        private drugSelected: boolean = false;
        private isLoading = false;
        private drugSearch: Drug | null = new Drug();
        private gsddDrug: Drug | null = new Drug();
        private gsddDrugPackageId: number = 0;
        private nonGSDDDrug: NonGSDDDrug | null = new NonGSDDDrug;
        // private gsddMatchDisplay: Array<any> = []; //this.gsddDrugMatch.forEach(function(element) {return  element.toString()});
        private drugSourceSelected: string | null = null
        private drugIdSelected: string | null = null;
        private gsddStatus: number | null = null;
        private nonGSDDStatus: string | null = null; //DrugStatus.DrugStatusEnum[this.gsddDrug.status.status];
        private nonGSDDTitle: string = "NonGSDD Drug";
        private gsddTitle: string = "GSDD Drug";
        private compoundDrug: CompoundDrug | null = null;
        private compoundTitle: string = "Compound Drug";
        private ingredientQuantity: number = 0;
        private ingredientUom: string = "";

        get awp(): any {
            if (!this.nonGSDDDrug || !this.nonGSDDDrug.awp) return ``;
            return `${this.nonGSDDDrug.awp}`;
        }

        get packageSize(): any {
            if (!this.nonGSDDDrug || !this.nonGSDDDrug.packageSize) return ``;
            return `${this.nonGSDDDrug.packageSize}`;
        }

        get unitOfMeasure(): any {
            if (!this.nonGSDDDrug) return ``;
            return this.nonGSDDDrug.unitOfMeasure;
        }

        get minimumDispenseQuantity(): any {
            if (!this.nonGSDDDrug || !this.nonGSDDDrug.minimumDispenseQuantity) return ``;
            return `${this.nonGSDDDrug.minimumDispenseQuantity}`;
        }

        get deaClass(): any {
            if (!this.nonGSDDDrug) return ``;
            return this.nonGSDDDrug.deaClass;
        }

        get disableFields(): boolean {
            return false
        }

        get marketer(): any {
            if (!this.gsddDrug) return ``;
            return this.gsddDrug.marketer;
        }

        get packageDescription(): any {
            if (!this.gsddDrug) return ``;
            return this.gsddDrug.packageDescription;
        }

        get doseForm(): any {
            if (!this.gsddDrug) return ``;
            return this.gsddDrug.doseForm;
        }

        get gsddDeaClass(): any {
            if (!this.gsddDrug) return ``;
            return this.gsddDrug.deaClass;
        }

        get gsddPackageSize(): any {
            if (!this.gsddDrug || !this.gsddDrug.packageSize || !this.gsddDrug.billingUnit) return ``;
            return `${this.gsddDrug.packageSize} ${this.gsddDrug.billingUnit}`;
        }

        // from Price
        get drugPrice(): any {
            if (!this.gsddDrug || !this.gsddDrug.prices) return ``;
            const filteredPrices = this.gsddDrug.prices as PackagePrice[];

            // 1  -- Average Wholesale Price
            // 13 -- Calculated Average Wholesale Price
            // 2  -- Wholesale Acquisition Cost
            const awp = filteredPrices.find(p => p.priceTypeID == 1 || p.priceTypeID == 13);
            const wac = filteredPrices.find(p => p.priceTypeID == 2);

            const awpString = awp && awp.unitPrice ? `AWP: $${awp.unitPrice}/${awp.ncpdpBillingUnit}` : ``;
            const wacString = wac && wac.unitPrice ? `WAC: $${wac.unitPrice}/${wac.ncpdpBillingUnit}` : ``;

            return `${awpString} ${wacString}`;
        }

        // Compound Drug computed properties
        get compoundName(): any {
            if (!this.compoundDrug || !this.compoundDrug.name) return ``;
            return this.compoundDrug.name;
        }

        get compoundAwp(): any {
            if (!this.compoundDrug || !this.compoundDrug.awp) return ``;
            return `$${this.compoundDrug.awp}`;
        }

        get compoundPackageSize(): any {
            if (!this.compoundDrug || !this.compoundDrug.packageSize) return ``;
            return this.compoundDrug.packageSize;
        }

        get compoundUnitOfMeasure(): any {
            if (!this.compoundDrug) return ``;
            return this.compoundDrug.unitOfMeasure;
        }

        get compoundMinimumDispenseQuantity(): any {
            if (!this.compoundDrug || !this.compoundDrug.minimumDispenseQuantity) return ``;
            return this.compoundDrug.minimumDispenseQuantity;
        }

        get compoundDeaClass(): any {
            if (!this.compoundDrug) return ``;
            return this.compoundDrug.deaClass;
        }

        get compoundStatus(): any {
            if (!this.compoundDrug) return ``;
            return DrugStatus.DrugStatusEnum[this.compoundDrug.status];
        }

        get compoundIngredientsCount(): any {
            if (!this.compoundDrug || !this.compoundDrug.ingredients) return `0`;
            return `${this.compoundDrug.ingredients.length} ingredient(s)`;
        }

        created() {
        }

        clearClicked() {
            this.drugSelected = false;
            this.drugSearch = new Drug();
            this.gsddDrug = new Drug();
            this.nonGSDDDrug = new NonGSDDDrug();
            this.compoundDrug = null;
            this.gsddDrugPackageId = -1;
            this.drugSourceSelected = null;
            this.drugIdSelected = null;
            this.ingredientQuantity = 0;
        }

        onDrugSearchSelected() {
            this.drugSourceSelected = this.drugSearch!.source.toString();
            this.drugIdSelected = this.drugSearch!.drugId.toString();

            // Prevent circular reference: compound cannot be added to itself
            if (this.drugSearch?.source == DrugSource.CompoundProduct &&
                this.drugIdSelected == this.currentCompoundId?.toString()) {
                this.$bvModal.msgBoxOk(`Cannot add a compound to itself as an ingredient`);
                return;
            }

            if (this.drugSearch?.source == DrugSource.GsddFederal) {
                this.onGSDDDrugSelected();
            }
            if (this.drugSearch?.source == DrugSource.NonGsddProduct) {
                this.onNonGSDDDrugSelected();
            }
            if (this.drugSearch?.source == DrugSource.CompoundProduct) {
                this.onCompoundDrugSelected();
            }
        }

        onCancelClicked() {
            this.$emit('cancel');
        }

        onGSDDDrugSelected() {
            this.drugSelected = true;
            const PackageID = this.drugSearch?.drugId;
            const packageId = Number(PackageID || 0);
            this.gsddDrug = new Drug();
            this.gsddDrugPackageId = packageId;
            this.nonGSDDDrug = new NonGSDDDrug();
            this.fetchGSDDDrug(packageId);
        }

        onNonGSDDDrugSelected() {
            this.drugSelected = true;
            const ProductID = this.drugSearch?.drugId;
            const productId = Number(ProductID || 0);
            this.gsddDrug = new Drug();
            this.gsddDrugPackageId = 0;
            this.nonGSDDDrug = new NonGSDDDrug();
            this.fetchNonGSDDDrug(productId);
        }

        onCompoundDrugSelected() {
            this.drugSelected = true;
            const CompoundID = this.drugSearch?.drugId;
            const compoundId = Number(CompoundID || 0);
            this.gsddDrug = new Drug();
            this.gsddDrugPackageId = 0;
            this.nonGSDDDrug = new NonGSDDDrug();
            this.fetchCompoundDrug(compoundId);
        }

        fetchGSDDDrug(packageID: number) {
            if (!packageID) return;

            Axios.get<Drug>(`/Drug/${packageID}`, { params: { getCategories: true, getVendors: true } })
                .then(response => {
                    const drug = response.data;
                    this.gsddDrug = new Drug(null, drug);
                    this.gsddStatus = drug.activeStatus;
                })
                .catch(error => {
                    console.error('Problem while getting drug details.', { error, response: error?.response });
                    this.$notification(NotificationOptions.error(error));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }

        fetchNonGSDDDrug(productID: number) {
            if (!productID) return;

            Axios.get<NonGSDDDrug>(`/NonGSDD/${productID}`)
                .then(response => {
                    const drug = response.data;
                    this.nonGSDDDrug = new NonGSDDDrug(null, drug);
                    this.nonGSDDStatus = DrugStatus.DrugStatusEnum[drug.activeStatus];
                })
                .catch(error => {
                    console.error('Problem while getting NonGSDD drug details.', { error, response: error?.response });
                    this.$notification(NotificationOptions.error(error));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }

        fetchCompoundDrug(compoundID: number) {
            if (!compoundID) return;

            Axios.get<CompoundDrug>(`/Compound/${compoundID}`)
                .then(response => {
                    const drug = response.data;
                    this.compoundDrug = drug;
                })
                .catch(error => {
                    console.error('Problem while getting compound drug details.', { error, response: error?.response });
                    this.$notification(NotificationOptions.error(error));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }

        onSaveClicked() {
            if (this.ingredientQuantity < 0.0001) {
                this.$bvModal.msgBoxOk('Quantity must be specified.');
                return;
            } else if (this.ingredientUom == null || this.ingredientUom == "") {
                this.$bvModal.msgBoxOk('Unit of Measure must be specified.');
                return;
            } else if (this.ingredientUom.length > 5 || this.ingredientUom.indexOf("_") > -1) {
                this.$bvModal.msgBoxOk('Unit of Measure can not exceed maximum of 5 characters or have any special characters.');
                return;
            }
            this.$emit('select', this.drugSourceSelected + "_" + this.drugIdSelected + "_" + this.ingredientQuantity.toString() + "_" + this.ingredientUom);
        }

    }
</script>

<style scoped>
</style>
